import { atom } from 'recoil';
import { TransactionPricingOfferPayload } from 'types/graphql';

export const transactionOfferAtom = atom<TransactionPricingOfferPayload>({
    key: 'transactionOffer',
    default: {},
});

export const complianceChargeDefaultsAtom = atom<
    {
        amount: number;
        name: string;
        type: string;
        highestRate: number;
        lowestRate: number;
        hint: string;
        label: string;
        note: string;
        chargeType: string;
    }[]
>({
    key: 'complianceChargeDefaults',
    default: [],
});
